@if (showForm) {
    <mijn-feedback-form
        [moodTitle]="moodTitle"
        [mood]="mood"
        (feedback)="onFeedback($event)"
        (cancel)="onCancel()"
        (toContact)="onContact()"
    >
    </mijn-feedback-form>
}
@if (!showForm) {
    <div data-bb="thankYouMessage" role="status">
        <h2>{{ 'mijn-feedback.feedbackModal.thankYou.title' | apContent }}</h2>
        @if (customThankyouMessage) {
            <p>{{ customThankyouMessage }}</p>
        } @else {
            <p>{{ 'mijn-feedback.feedbackModal.thankYou.info' | apContent }}</p>
        }
        <ap-button (onClick)="accept()">{{ 'mijn-feedback.feedbackModal.thankYou.button' | apContent }}</ap-button>
    </div>
}
